import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import { checkSession } from "./api/auth";
import NProgress from 'nprogress';

import Dashboard from "./views/dashboard/Dashboard.vue";
import siteDashboard from "./views/dashboard/Sites.vue";
import serverDashboard from "./views/dashboard/Servers.vue";
import Login from "./views/Login.vue";

// Import css
import '../node_modules/nprogress/nprogress.css'

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      alias: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      children: [
        {
          path: "/dashboard/sites",
          alias: "/",
          name: "siteDashboard",
          component: siteDashboard,
          meta: {
            section: "dashboardSites",
            name: "dashboardSites"
          }
        },
        {
          path: "/dashboard/servers",
          name: "serverDashboard",
          component: serverDashboard,
          meta: {
            section: "dashboardServers",
            name: "dashboardServers"
          }
        }
      ],
      meta: {
        menu: "dashboard",
        name: "dashboard"
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        menu: "login",
        name: "login"
      }
    },
    {
      path: "/sites",
      component: () =>
        import(/* webpackChunkName: "sites" */ "./views/sites/Sites.vue"),
      children: [
        {
          path: "/",
          name: "sitesList",
          component: () =>
            import(/* webpackChunkName: "sitesList" */ "./views/sites/SitesList.vue"),
          meta: {
            name: "sites"
          }
        },
        {
          path: "/sites/new",
          name: "sitesNew",
          component: () =>
            import(/* webpackChunkName: "sitesNew" */ "./views/sites/SitesNew.vue"),
          meta: {
            name: "newSite"
          }
        },
        {
          path: "/sites/:id/edit",
          name: "sitesEdit",
          component: () =>
            import(/* webpackChunkName: "sitesEdit" */ "./views/sites/SitesEdit.vue"),
          meta: {
            name: "editSite"
          }
        },
        {
          path: "/sites/:id/details",
          name: "sitesDetails",
          component: () =>
            import(/* webpackChunkName: "sitesDetails" */ "./views/sites/SitesDetails.vue"),
          meta: {
            name: "siteDetails"
          }
        }
      ],
      meta: {
        menu: "sites",
        requiresAuth: true
      }
    },
    {
      path: "/servers",
      component: () =>
        import(/* webpackChunkName: "servers" */ "./views/servers/Servers.vue"),
      children: [
        {
          path: "/",
          name: "serversList",
          component: () =>
            import(/* webpackChunkName: "serversList" */ "./views/servers/ServersList.vue"),
          meta: {
            name: "servers"
          }
        },
        {
          path: "/servers/new",
          name: "serversNew",
          component: () =>
            import(/* webpackChunkName: "serversNew" */ "./views/servers/ServersNew.vue"),
          meta: {
            name: "newServer"
          }
        },
        {
          path: "/servers/:id/edit",
          name: "serversEdit",
          component: () =>
            import(/* webpackChunkName: "serversEdit" */ "./views/servers/ServersEdit.vue"),
          meta: {
            name: "editServer"
          }
        },
        {
          path: "/servers/:id/details",
          name: "serversDetails",
          component: () =>
            import(/* webpackChunkName: "serversDetails" */ "./views/servers/ServersDetails.vue"),
          meta: {
            name: "serverDetails"
          }
        }
      ],
      meta: {
        menu: "servers",
        requiresAuth: true
      }
    },
    {
      path: "/users",
      component: () =>
        import(/* webpackChunkName: "users" */ "./views/users/Users.vue"),
      children: [
        {
          path: "/",
          name: "usersList",
          component: () =>
            import(/* webpackChunkName: "usersList" */ "./views/users/UsersList.vue"),
          meta: {
            name: "users"
          }
        },
        {
          path: "/users/new",
          name: "usersNew",
          component: () =>
            import(/* webpackChunkName: "usersNew" */ "./views/users/UsersNew.vue"),
          meta: {
            name: "newUser"
          }
        },
        {
          path: "/users/:id/edit",
          name: "usersEdit",
          component: () =>
            import(/* webpackChunkName: "usersEdit" */ "./views/users/UsersEdit.vue"),
          meta: {
            name: "editUser"
          }
        },
        {
          path: "/users/:id/details",
          name: "usersDetails",
          component: () =>
            import(/* webpackChunkName: "usersDetails" */ "./views/users/UsersDetails.vue"),
          meta: {
            name: "userDetails"
          }
        }
      ],
      meta: {
        menu: "users",
        requiresAuth: true
      }
    },
    {
      path: "/financial",
      component: () =>
        import(/* webpackChunkName: "financial" */ "./views/financial/Financial.vue"),
      children: [
        {
          path: "/",
          name: "financial",
          component: () =>
            import(/* webpackChunkName: "financial" */ "./views/financial/FinancialList.vue"),
          meta: {
            name: "financial"
          }
        }
      ],
      meta: {
        menu: "Financial",
        requiresAuth: true
      }
    },
    {
      path: "/providers",
      component: () =>
        import(/* webpackChunkName: "financial" */ "./views/providers/Providers.vue"),
      children: [
        {
          path: "/",
          name: "providers",
          component: () =>
            import(/* webpackChunkName: "providers" */ "./views/providers/ProvidersList.vue"),
          meta: {
            name: "providers"
          }
        },
        {
          path: "/providers/:id",
          name: "ProvidersDetails",
          component: () =>
            import(/* webpackChunkName: "financial" */ "./views/providers/ProvidersDetails.vue"),
          meta: {
            name: "providerDetails"
          }
        }
      ],
      meta: {
        menu: "Providers",
        requiresAuth: true
      }
    },
    {
      path: "/types",
      component: () =>
        import(/* webpackChunkName: "siteTypes" */ "./views/siteTypes/SiteTypes.vue"),
      children: [
        {
          path: "/",
          name: "types",
          component: () =>
            import(/* webpackChunkName: "siteTypes" */ "./views/siteTypes/SiteTypesList.vue"),
          meta: {
            name: "siteTypes"
          }
        },
        {
          path: "/types/:id/details",
          name: "SiteTypesDetails",
          component: () =>
            import(/* webpackChunkName: "siteTypes" */ "./views/siteTypes/SiteTypesDetails.vue"),
          meta: {
            name: "siteTypesDetails"
          }
        }
      ],
      meta: {
        menu: "SiteTypes",
        requiresAuth: true
      }
    },
    {
      path: "/projects",
      component: () =>
        import(/* webpackChunkName: "projects" */ "./views/projects/Projects.vue"),
      children: [
        {
          path: "/",
          name: "projectsList",
          component: () =>
            import(/* webpackChunkName: "projectsList" */ "./views/projects/ProjectsList.vue"),
          meta: {
            name: "project"
          }
        },
        {
          path: "/projects/new",
          name: "projectsNew",
          component: () =>
            import(/* webpackChunkName: "projectsNew" */ "./views/projects/ProjectsNew.vue"),
          meta: {
            name: "newProject"
          }
        },
        {
          path: "/projects/:id/edit",
          name: "projectsEdit",
          component: () =>
            import(/* webpackChunkName: "projectsEdit" */ "./views/projects/ProjectsEdit.vue"),
          meta: {
            name: "editProject"
          }
        },
        {
          path: "/projects/:id/details",
          name: "projectsDetails",
          component: () =>
            import(/* webpackChunkName: "projectsDetails" */ "./views/projects/ProjectsDetails.vue"),
          meta: {
            name: "projectDetails"
          }
        }
      ],
      meta: {
        menu: "projects",
        requiresAuth: true
      }
    },
    {
      path: "/maintenances",
      component: () =>
        import(/* webpackChunkName: "maintenances" */ "./views/maintenances/Maintenances.vue"),
      children: [
        {
          path: "/",
          name: "maintenancesList",
          component: () =>
            import(/* webpackChunkName: "maintenanceList" */ "./views/maintenances/MaintenancesList.vue"),
          meta: {
            name: "maintenances"
          }
        },
        {
          path: "/maintenances/new",
          name: "maintenancesNew",
          component: () =>
            import(/* webpackChunkName: "maintenancesNew" */ "./views/maintenances/MaintenancesNew.vue"),
          meta: {
            name: "newMaintenance"
          }
        },
        {
          path: "/maintenances/:id/edit",
          name: "maintenancesEdit",
          component: () =>
            import(/* webpackChunkName: "maintenancesEdit" */ "./views/maintenances/MaintenancesEdit.vue"),
          meta: {
            name: "editMaintenance"
          }
        },
        {
          path: "/maintenances/:id/details",
          name: "maintenancesDetails",
          component: () =>
            import(/* webpackChunkName: "maintenancesDetails" */ "./views/maintenances/MaintenancesDetails.vue"),
          meta: {
            name: "maintenanceDetails"
          }
        }
      ],
      meta: {
        menu: "maintenances",
        requiresAuth: true
      }
    },
    {
      path: "/monitorings",
      component: () =>
        import(/* webpackChunkName: "monitorings" */ "./views/monitorings/Monitorings.vue"),
      children: [
        {
          path: "/",
          name: "monitorings",
          component: () =>
            import(/* webpackChunkName: "monitorings" */ "./views/monitorings/MonitoringsList.vue"),
          meta: {
            name: "monitorings",
            group: "employees"
          }
        },
        {
          path: "/monitorings/new",
          name: "monitoringsNew",
          component: () =>
            import(/* webpackChunkName: "monitoringsNew" */ "./views/monitorings/MonitoringsNew.vue"),
          meta: {
            name: "newMonitoring",
            group: "employees"
          }
        },
        {
          path: "/monitorings/:id/edit",
          name: "monitoringsEdit",
          component: () =>
            import(/* webpackChunkName: "monitoringsEdit" */ "./views/monitorings/MonitoringsEdit.vue"),
          meta: {
            name: "editMonitoring",
            group: "employees"
          }
        },
      ],
      meta: {
        menu: "monitorings",
        requiresAuth: true
      }
    },
    {
      path: "/employees",
      component: () =>
        import(/* webpackChunkName: "employees" */ "./views/employees/Employees.vue"),
      children: [
        {
          path: "/",
          name: "employees",
          component: () =>
            import(/* webpackChunkName: "employees" */ "./views/employees/EmployeesList.vue"),
          meta: {
            name: "employees",
            group: "employees"
          }
        },
        {
          path: "/employees/new",
          name: "employeesNew",
          component: () =>
            import(/* webpackChunkName: "employeesNew" */ "./views/employees/EmployeesNew.vue"),
          meta: {
            name: "newEmployee",
            group: "employees"
          }
        },
        {
          path: "/employees/:id/edit",
          name: "employeesEdit",
          component: () =>
            import(/* webpackChunkName: "employeesEdit" */ "./views/employees/EmployeesEdit.vue"),
          meta: {
            name: "editEmployee",
            group: "employees"
          }
        },
      ],
      meta: {
        menu: "employees",
        requiresAuth: true
      }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/page/About.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/setup",
      name: "setup",
      component: () =>
        import(/* webpackChunkName: "setup" */ "./views/Setup.vue"),
      meta: {
        menu: "setup",
        requiresAuth: false,
        name: "setup"
      }
    },
    {
      path: "/404",
      name: "error",
      component: () =>
        import(/* webpackChunkName: "setup" */ "./views/page/Error.vue"),
      meta: {
        menu: "Error",
        requiresAuth: false,
        name: "Error404"
      }
    },
    { path: "*", redirect: "/404" }
  ]
});

const intervals = [];

NProgress.configure({
  easing: 'ease',
  speed: 1000,
  showSpinner: false
});

router.beforeEach(async (to, from, next) => {
  let domain = window.localStorage.getItem("domain");
  if (!domain && to.name != "setup")
    return next({
      path: "/setup"
    });

  // Unstore password when we are not on an 'employee' page
  if (store.state.employeePwd) {
    if (!to.meta.group || to.meta.group != "employees") {
      store.dispatch("setEmployeePwd", "");
      store.dispatch("setProject", "");
    }
  }
  // By default, each page requires use to be authenticated to be accessed
  if (to.matched.some(route => !("requiresAuth" in route.meta)) == true) {
    let token = window.localStorage.getItem("token");

    // If there is no token is session, we redirect to login page
    if (!token && to.name != "login")
      return next({
        path: "/login"
      });
    else if (to.name == "login") return next();
    // We now check the validity of the jwt by getting logged user info
    try {
      console.log("[info] check session validity ...");
      await checkSession(store.getters.getUserId);
      const interval = setInterval(async () => {
        console.log("[info] check session validity ...");
        try {
          await checkSession(store.getters.getUserId);
        } catch (error) {
          _handleSessionError(error, next);
        }
      }, 30 * 60 * 1000);
      intervals.push(interval);
    } catch (error) {
      _handleSessionError(error, next);
    }
  }
  return next();
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) { NProgress.start(); }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

function _handleSessionError(error, next) {
  console.log("[info] session expired !");
  store.dispatch("logout");
  intervals.map(interval => {
    clearInterval(interval);
  });
  return next({ path: "/login" });
}

export default router;
